import React from "react";
import { ArrowPathIcon } from "@heroicons/react/24/solid";

const LoaderButton = React.forwardRef(
    (
        {
            type = "button",
            loading = false,
            title,
            className,
            overrideClasses,
            disabled = false,
            ...props
        },
        ref
    ) => {
        const defaultClassNames =
            "flex gap-x-2 items-center justify-center bg-blue-500 hover:bg-blue-500 focus:bg-blue-500 text-white rounded-lg px-5 py-2 font-semibold";
        const classNames = overrideClasses
            ? overrideClasses
            : className
            ? `${defaultClassNames} ${className}`
            : defaultClassNames;

        return (
            <button
                type={type}
                ref={ref}
                className={classNames}
                {...props}
                disabled={disabled || loading}
            >
                {loading ? (
                    <ArrowPathIcon className="w-6 h-6 animate-spin" />
                ) : null}
                {title && <p>{title}</p>}
            </button>
        );
    }
);

export default LoaderButton;
